import { CheckIcon } from '@heroicons/react/outline';

const authentications = [
  {
    name: 'Passwords',
    description: (
      <>
        Not just any "magic word" is safe &ndash; we use HaveIBeenPwned to block
        credential stuffing
      </>
    )
  },
  {
    name: 'OAuth & Social',
    description:
      "The fastest solution to signing in, and it's preferred by most users when available"
  },
  {
    name: 'Email Passcodes (OTP)',
    description: (
      <>
        Ask users to relay a 6 digit passcode sent to their email &ndash; simple
        but effective!
      </>
    )
  },
  {
    name: 'Email Magic Links',
    description:
      'Made popular by Slack, send users a link that automatically signs them in'
  },
  {
    name: 'Web3 (Metamask)',
    description:
      'Fast like OAuth, but with a privacy-conscious keypair instead of a third-party vendor'
  },
  {
    name: 'SMS Passcodes (OTP)',
    description: (
      <>
        Ask users to relay a 6 digit passcode sent to their phone &ndash; great
        for mobile!
      </>
    )
  }
];

export function AuthYourWay() {
  return (
    <div className="mt-10 ">
      <div className="relative mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="relative lg:grid lg:grid-cols-3 lg:gap-x-8">
          <div className="lg:col-span-1">
            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Authenticate users any way you want
            </h2>
            <p className="mt-3 max-w-3xl text-lg text-gray-500">
              Easily choose one or many ways for your users to sign in.
            </p>
          </div>
          <div className="mt-12 lg:col-span-2 lg:mt-0">
            <dl className="space-y-10 sm:grid sm:grid-flow-col sm:grid-cols-2 sm:grid-rows-3 sm:gap-x-6 sm:gap-y-10 sm:space-y-0 lg:gap-x-8">
              {authentications.map(feature => (
                <div key={feature.name} className="relative">
                  <dt>
                    <CheckIcon
                      className="absolute h-6 w-6 text-green-500"
                      aria-hidden="true"
                    />
                    <p className="ml-9 text-lg font-medium leading-6 text-gray-900">
                      {feature.name}
                    </p>
                  </dt>
                  <dd className="mt-2 ml-9 text-base text-gray-500">
                    {feature.description}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}
